(function () {
  'use strict';

  var PHI = (1 + Math.sqrt(5)) / 2;
  var PENTAGON_CENTERS = [
    [0, 1, PHI], [0, -1, PHI], [0, 1, -PHI], [0, -1, -PHI],
    [1, PHI, 0], [-1, PHI, 0], [1, -PHI, 0], [-1, -PHI, 0],
    [PHI, 0, 1], [-PHI, 0, 1], [PHI, 0, -1], [-PHI, 0, -1]
  ].map(function (v) {
    var len = Math.hypot(v[0], v[1], v[2]);
    return [v[0] / len, v[1] / len, v[2] / len];
  });

  var SPIN_AXIS = [0.55, 1, 0.38];
  var SPIN_LEN = Math.hypot(SPIN_AXIS[0], SPIN_AXIS[1], SPIN_AXIS[2]);
  SPIN_AXIS = [SPIN_AXIS[0] / SPIN_LEN, SPIN_AXIS[1] / SPIN_LEN, SPIN_AXIS[2] / SPIN_LEN];

  var WOBBLE_AXIS = [0.25, 0.45, 1];
  var WOBBLE_LEN = Math.hypot(WOBBLE_AXIS[0], WOBBLE_AXIS[1], WOBBLE_AXIS[2]);
  WOBBLE_AXIS = [WOBBLE_AXIS[0] / WOBBLE_LEN, WOBBLE_AXIS[1] / WOBBLE_LEN, WOBBLE_AXIS[2] / WOBBLE_LEN];

  function createShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      console.warn('worldcup-ball shader', gl.getShaderInfoLog(shader));
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  function createProgram(gl, vsSource, fsSource) {
    var vs = createShader(gl, gl.VERTEX_SHADER, vsSource);
    var fs = createShader(gl, gl.FRAGMENT_SHADER, fsSource);
    if (!vs || !fs) return null;
    var program = gl.createProgram();
    gl.attachShader(program, vs);
    gl.attachShader(program, fs);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      console.warn('worldcup-ball program', gl.getProgramInfoLog(program));
      return null;
    }
    return program;
  }

  function buildSphere(radius, latBands, longBands) {
    var positions = [];
    var normals = [];
    var indices = [];

    for (var lat = 0; lat <= latBands; lat++) {
      var theta = (lat * Math.PI) / latBands;
      var sinTheta = Math.sin(theta);
      var cosTheta = Math.cos(theta);

      for (var lon = 0; lon <= longBands; lon++) {
        var phi = (lon * 2 * Math.PI) / longBands;
        var sinPhi = Math.sin(phi);
        var cosPhi = Math.cos(phi);

        var x = cosPhi * sinTheta;
        var y = cosTheta;
        var z = sinPhi * sinTheta;

        normals.push(x, y, z);
        positions.push(x * radius, y * radius, z * radius);
      }
    }

    for (var latIdx = 0; latIdx < latBands; latIdx++) {
      for (var lonIdx = 0; lonIdx < longBands; lonIdx++) {
        var first = latIdx * (longBands + 1) + lonIdx;
        var second = first + longBands + 1;
        indices.push(first, second, first + 1);
        indices.push(second, second + 1, first + 1);
      }
    }

    return { positions: positions, normals: normals, indices: indices };
  }

  function mat4Perspective(out, fovy, aspect, near, far) {
    var f = 1 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) / (near - far);
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = (2 * far * near) / (near - far);
    out[15] = 0;
    return out;
  }

  function mat4Multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4]; b1 = b[5]; b2 = b[6]; b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8]; b1 = b[9]; b2 = b[10]; b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12]; b1 = b[13]; b2 = b[14]; b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a33;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
  }

  function mat4RotateAxis(out, axis, angle) {
    var x = axis[0], y = axis[1], z = axis[2];
    var c = Math.cos(angle);
    var s = Math.sin(angle);
    var t = 1 - c;
    out[0] = t * x * x + c;
    out[1] = t * x * y + s * z;
    out[2] = t * x * z - s * y;
    out[3] = 0;
    out[4] = t * x * y - s * z;
    out[5] = t * y * y + c;
    out[6] = t * y * z + s * x;
    out[7] = 0;
    out[8] = t * x * z + s * y;
    out[9] = t * y * z - s * x;
    out[10] = t * z * z + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
  }

  function mat4Identity(out) {
    out[0] = 1; out[1] = 0; out[2] = 0; out[3] = 0;
    out[4] = 0; out[5] = 1; out[6] = 0; out[7] = 0;
    out[8] = 0; out[9] = 0; out[10] = 1; out[11] = 0;
    out[12] = 0; out[13] = 0; out[14] = 0; out[15] = 1;
    return out;
  }

  var VS = [
    'attribute vec3 aPosition;',
    'attribute vec3 aNormal;',
    'uniform mat4 uModel;',
    'uniform mat4 uView;',
    'uniform mat4 uProjection;',
    'varying vec3 vNormal;',
    'varying vec3 vViewNormal;',
    'void main(void) {',
    '  vec3 n = mat3(uModel) * aNormal;',
    '  vNormal = normalize(n);',
    '  vViewNormal = normalize((uView * uModel * vec4(aNormal, 0.0)).xyz);',
    '  gl_Position = uProjection * uView * uModel * vec4(aPosition, 1.0);',
    '}'
  ].join('\n');

  var FS = [
    'precision mediump float;',
    'varying vec3 vNormal;',
    'varying vec3 vViewNormal;',
    'uniform vec3 uPent0; uniform vec3 uPent1; uniform vec3 uPent2; uniform vec3 uPent3;',
    'uniform vec3 uPent4; uniform vec3 uPent5; uniform vec3 uPent6; uniform vec3 uPent7;',
    'uniform vec3 uPent8; uniform vec3 uPent9; uniform vec3 uPent10; uniform vec3 uPent11;',
    'void main(void) {',
    '  vec3 n = normalize(vNormal);',
    '  vec3 vn = normalize(vViewNormal);',
    '  vec3 pents[12];',
    '  pents[0]=uPent0; pents[1]=uPent1; pents[2]=uPent2; pents[3]=uPent3;',
    '  pents[4]=uPent4; pents[5]=uPent5; pents[6]=uPent6; pents[7]=uPent7;',
    '  pents[8]=uPent8; pents[9]=uPent9; pents[10]=uPent10; pents[11]=uPent11;',
    '  float pent = 0.0;',
    '  float bestIdx = 0.0;',
    '  for (int i = 0; i < 12; i++) {',
    '    float d = dot(n, pents[i]);',
    '    float m = smoothstep(0.86, 0.955, d);',
    '    if (m > pent) { pent = m; bestIdx = float(i); }',
    '  }',
    // World Cup 2026 palette on a clean white base — no shadowing.
    '  vec3 white = vec3(1.0, 1.0, 1.0);',
    '  vec3 red = vec3(0.89, 0.0, 0.17);',
    '  vec3 blue = vec3(0.0, 0.40, 0.73);',
    '  vec3 green = vec3(0.0, 0.62, 0.34);',
    '  float sel = mod(bestIdx, 3.0);',
    '  vec3 panel = red;',
    '  if (sel > 1.5) { panel = green; } else if (sel > 0.5) { panel = blue; }',
    '  vec3 col = mix(white, panel, pent);',
    '  vec3 light = normalize(vec3(0.25, 0.7, 0.7));',
    '  float diff = max(dot(n, light), 0.0);',
    '  vec3 viewDir = vec3(0.0, 0.0, 1.0);',
    '  vec3 halfVec = normalize(light + viewDir);',
    '  float spec = pow(max(dot(n, halfVec), 0.0), 42.0);',
    // High ambient keeps every panel bright and evenly lit (no dark side).
    '  col = col * (0.92 + diff * 0.12) + spec * 0.18;',
    '  gl_FragColor = vec4(min(col, 1.0), 1.0);',
    '}'
  ].join('\n');

  function WorldcupBall(canvas) {
    this.canvas = canvas;
    this.gl = canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false });
    this.running = false;
    this.spin = 0;
    this.spinSpeed = 0.038;
    this.rollAngle = 0;
    this.isRolling = false;
    this.hoverBoost = 0;
    this.tiltX = 0;
    this.tiltY = 0;
    this.targetTiltX = 0;
    this.targetTiltY = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.gl) return;

    this.program = createProgram(this.gl, VS, FS);
    if (!this.program) return;

    var sphere = buildSphere(1, 48, 48);
    var gl = this.gl;

    this.positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(sphere.positions), gl.STATIC_DRAW);

    this.normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this.normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(sphere.normals), gl.STATIC_DRAW);

    this.indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(sphere.indices), gl.STATIC_DRAW);
    this.indexCount = sphere.indices.length;

    this.aPosition = gl.getAttribLocation(this.program, 'aPosition');
    this.aNormal = gl.getAttribLocation(this.program, 'aNormal');
    this.uModel = gl.getUniformLocation(this.program, 'uModel');
    this.uView = gl.getUniformLocation(this.program, 'uView');
    this.uProjection = gl.getUniformLocation(this.program, 'uProjection');
    this.uPentLocs = [];
    for (var i = 0; i < 12; i++) {
      this.uPentLocs.push(gl.getUniformLocation(this.program, 'uPent' + i));
    }

    this.model = new Float32Array(16);
    this.view = new Float32Array(16);
    this.projection = new Float32Array(16);
    this.tmp = new Float32Array(16);
    this.tmp2 = new Float32Array(16);
    this.tmp3 = new Float32Array(16);

    mat4Identity(this.view);
    this.view[14] = -2.65;

    gl.enable(gl.DEPTH_TEST);
    gl.enable(gl.CULL_FACE);

    this.resize();
    this.bindEvents();
    this.running = true;
    this.tick();
  }

  WorldcupBall.prototype.resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var link = this.canvas.closest('.worldcup-header-ball');
    var rect = link ? link.getBoundingClientRect() : this.canvas.getBoundingClientRect();
    var size = Math.max(32, Math.round(rect.width || 56));
    this.canvas.style.width = size + 'px';
    this.canvas.style.height = size + 'px';
    this.canvas.width = Math.round(size * dpr);
    this.canvas.height = Math.round(size * dpr);
    this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
    mat4Perspective(this.projection, Math.PI / 3.4, 1, 0.1, 10);
  };

  WorldcupBall.prototype.bindEvents = function () {
    var self = this;
    var link = this.canvas.closest('.worldcup-header-ball');

    window.addEventListener('resize', function () {
      self.resize();
    }, { passive: true });

    if (link) {
      link.addEventListener('mouseenter', function () {
        self.hoverBoost = 0.022;
      });
      link.addEventListener('mouseleave', function () {
        self.hoverBoost = 0;
        self.targetTiltX = 0;
        self.targetTiltY = 0;
      });
      link.addEventListener('mousemove', function (event) {
        var rect = link.getBoundingClientRect();
        var nx = (event.clientX - rect.left) / rect.width - 0.5;
        var ny = (event.clientY - rect.top) / rect.height - 0.5;
        self.targetTiltY = nx * 0.55;
        self.targetTiltX = -ny * 0.4;
      });
    }

    if (window.ResizeObserver && link) {
      var ro = new ResizeObserver(function () {
        self.resize();
      });
      ro.observe(link);
    }
  };

  WorldcupBall.prototype.tick = function () {
    if (!this.running) return;

    if (!this.reducedMotion) {
      if (!this.isRolling) {
        this.spin += this.spinSpeed + this.hoverBoost;
      } else if (this.hoverBoost) {
        this.spin += this.hoverBoost;
      }
      this.tiltX += (this.targetTiltX - this.tiltX) * 0.12;
      this.tiltY += (this.targetTiltY - this.tiltY) * 0.12;
    }

    this.draw();
    requestAnimationFrame(this.tick.bind(this));
  };

  WorldcupBall.prototype.draw = function () {
    var gl = this.gl;
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    gl.useProgram(this.program);

    mat4Identity(this.model);
    mat4Multiply(this.model, this.model, mat4RotateAxis(this.tmp, [0, 0, 1], this.rollAngle));
    if (this.isRolling) {
      mat4Multiply(this.model, this.model, mat4RotateAxis(this.tmp2, SPIN_AXIS, this.spin * 0.18));
    } else {
      mat4Multiply(this.model, this.model, mat4RotateAxis(this.tmp2, SPIN_AXIS, this.spin));
      mat4Multiply(this.model, this.model, mat4RotateAxis(this.tmp3, WOBBLE_AXIS, this.spin * 0.42));
    }
    if (this.tiltX || this.tiltY) {
      mat4Multiply(this.model, this.model, mat4RotateAxis(this.tmp3, [1, 0, 0], this.tiltX));
      mat4Multiply(this.model, this.model, mat4RotateAxis(this.tmp3, [0, 1, 0], this.tiltY));
    }

    gl.uniformMatrix4fv(this.uModel, false, this.model);
    gl.uniformMatrix4fv(this.uView, false, this.view);
    gl.uniformMatrix4fv(this.uProjection, false, this.projection);

    for (var i = 0; i < 12; i++) {
      gl.uniform3fv(this.uPentLocs[i], PENTAGON_CENTERS[i]);
    }

    gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer);
    gl.enableVertexAttribArray(this.aPosition);
    gl.vertexAttribPointer(this.aPosition, 3, gl.FLOAT, false, 0, 0);

    gl.bindBuffer(gl.ARRAY_BUFFER, this.normalBuffer);
    gl.enableVertexAttribArray(this.aNormal);
    gl.vertexAttribPointer(this.aNormal, 3, gl.FLOAT, false, 0, 0);

    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
    gl.drawElements(gl.TRIANGLES, this.indexCount, gl.UNSIGNED_SHORT, 0);
  };

  function easeOutCubic(t) {
    var u = 1 - t;
    return 1 - u * u * u;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function getMatchCountdownTarget() {
    return document.getElementById('match-countdown') || document.querySelector('[data-match-countdown]');
  }

  function scrollToMatchCountdown(behavior) {
    var target = getMatchCountdownTarget();
    if (!target) return false;
    target.scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#match-countdown');
    }
    return true;
  }

  function bindCountdownLink(el) {
    if (!el || el.__worldcupCountdownBound) return;
    el.__worldcupCountdownBound = true;
    el.addEventListener('click', function (event) {
      var href = el.getAttribute('href') || '';
      if (href.indexOf('match-countdown') === -1) return;
      if (!getMatchCountdownTarget()) return;
      event.preventDefault();
      scrollToMatchCountdown('smooth');
    });
  }

  var ROLLER_PHASES = {
    IDLE: 'idle',
    KICK: 'kick',
    HOLD: 'hold',
    RETURN: 'return'
  };

  function WorldcupBallRoller(track) {
    this.track = track;
    this.ball = track.querySelector('.worldcup-header-ball');
    this.canvas = track.querySelector('[data-worldcup-ball]');
    this.goal = track.querySelector('[data-worldcup-goal]');
    this.goalW = 80;
    this.scored = false;
    this.home = 0;
    this.x = 0;
    this.y = 0;
    this.scale = 1;
    this.minScale = 0.24;
    this.effMinScale = 0.24;
    this.noGoal = false;
    this.liftHeight = 22;
    this.arcApex = 40;
    this.travelX = 150;
    this.phase = ROLLER_PHASES.IDLE;
    this.phaseTime = 0;
    this.durations = {
      idle: 1.7,
      kick: 0.6,
      hold: 0.55,
      return: 0.9
    };
    this.paused = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.ball || !this.canvas) return;

    this.measure();
    this.bindEvents();
    this.scheduleRemeasure();
  }

  // Layout (fonts, menus, sticky header) can settle after first paint — remeasure a few times.
  WorldcupBallRoller.prototype.scheduleRemeasure = function () {
    var self = this;
    [120, 350, 800, 1500].forEach(function (t) {
      setTimeout(function () { self.measure(); }, t);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.measure(); }).catch(function () {});
    }
    window.addEventListener('load', function () { self.measure(); }, { once: true });
  };

  WorldcupBallRoller.prototype.bindEvents = function () {
    var self = this;

    window.addEventListener('resize', function () {
      self.measure();
    }, { passive: true });

    this.ball.addEventListener('mouseenter', function () {
      self.paused = true;
    });
    this.ball.addEventListener('mouseleave', function () {
      self.paused = false;
    });

    bindCountdownLink(this.ball);
    bindCountdownLink(this.goal);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        self.measure();
      });
      ro.observe(this.track);
    }
  };

  WorldcupBallRoller.prototype.measure = function () {
    var ballW = this.ball.offsetWidth || 56;
    var trackW = this.track.clientWidth || 0;
    this.canFly = trackW > 0;

    var mobile = trackW < 1024;
    this.arcApex = mobile ? 20 : 40;
    this.liftHeight = mobile ? 10 : 22;

    var gap = this.widestGap(trackW, ballW);
    var pad = 6;
    var a = gap[0] + pad;
    var b = gap[1] - pad;
    var width = Math.max(0, b - a);

    // Too tight to even rest the ball: park it (best-effort centered) and skip the kick/goal.
    if (width < ballW + 8) {
      this.noGoal = true;
      this.effMinScale = 0.72;
      this.goalScale = 0;
      this.travelX = 0;
      this.home = Math.round(a + Math.max(0, (width - ballW) / 2));
      this.x = this.home;
      if (this.goal) this.goal.style.opacity = '0';
      this.positionGoal(ballW);
      this.updatePosition();
      return;
    }

    // Size the goal to fit inside the gap (capped on big screens).
    this.goalScale = Math.max(0.5, Math.min(1.15, (width * 0.5) / this.goalW));
    var goalDrawW = this.goalW * this.goalScale;

    this.home = Math.round(a);
    this.x = this.home;

    // Distance the ball may fly so that BOTH the ball and the goal stay inside the gap.
    var maxTravel = b - this.home - ballW / 2 - goalDrawW / 2;

    if (maxTravel < 24) {
      // Enough room for the ball, but not for a goal — do a gentle in-place hop, no goal.
      this.noGoal = true;
      this.effMinScale = 0.72;
      this.goalScale = 0;
      this.travelX = 0;
      if (this.goal) this.goal.style.opacity = '0';
    } else {
      this.noGoal = false;
      this.effMinScale = this.minScale;
      this.travelX = Math.max(28, Math.min(170, width * 0.55, maxTravel));
    }

    this.positionGoal(ballW);
    this.updatePosition();
  };

  // Find the widest truly-empty horizontal span across the header row,
  // measured from the real icons/logo/links (not their padded containers).
  WorldcupBallRoller.prototype.widestGap = function (trackW, ballW) {
    var header = this.track.closest('header.header') || this.track.parentElement;
    var trackRect = this.track.getBoundingClientRect();
    var trackLeft = trackRect.left;

    // Reference the header-bar row from the TRACK centre (stable). The ball's own rect is
    // unreliable here because measure() can run mid-flight (ball raised/shrunk).
    var refY = (trackRect.top + trackRect.bottom) / 2;
    var band = Math.max(ballW || 44, 40); // row tolerance (half-height)
    var maxElH = band * 3.2; // ignore tall elements (dropdown panels, mega-menu images)

    // Robust visibility test — offsetParent is null for magnet/fixed menu wrappers, so we
    // can't rely on it; check rects + computed style instead.
    function isVisible(el) {
      if (!el.getClientRects().length) return false;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      if (parseFloat(cs.opacity || '1') === 0) return false;
      return true;
    }

    var intervals = [];
    // Include .btn-text so dropdown triggers (About us / Shop / Learn) are measured by
    // their visible label even when their <button> wrapper reports no offsetParent.
    header.querySelectorAll('a, button, svg, img, .btn-text').forEach(function (el) {
      if (el.closest('.worldcup-header-ball-track')) return;
      if (!isVisible(el)) return; // skips hidden desktop/mobile menus, etc.
      var b = el.getBoundingClientRect();
      if (b.width === 0 || b.height === 0) return;
      if (b.height > maxElH) return; // skip panels/large imagery, keep real bar items
      var cy = (b.top + b.bottom) / 2;
      if (Math.abs(cy - refY) > band) return; // only elements on the header-bar row
      var l = Math.max(0, b.left - trackLeft);
      var r = Math.min(trackW, b.right - trackLeft);
      if (r > l) intervals.push([l, r]);
    });

    if (!intervals.length) return [0, trackW];

    intervals.sort(function (p, q) { return p[0] - q[0]; });
    var merged = [intervals[0].slice()];
    for (var i = 1; i < intervals.length; i++) {
      var cur = intervals[i];
      var last = merged[merged.length - 1];
      if (cur[0] <= last[1] + 2) {
        last[1] = Math.max(last[1], cur[1]);
      } else {
        merged.push(cur.slice());
      }
    }

    var gaps = [];
    var prev = 0;
    for (var j = 0; j < merged.length; j++) {
      if (merged[j][0] - prev > 0) gaps.push([prev, merged[j][0]]);
      prev = Math.max(prev, merged[j][1]);
    }
    if (trackW - prev > 0) gaps.push([prev, trackW]);
    if (!gaps.length) gaps.push([0, trackW]);

    var best = gaps[0];
    for (var k = 1; k < gaps.length; k++) {
      if (gaps[k][1] - gaps[k][0] > best[1] - best[0]) best = gaps[k];
    }
    return best;
  };

  // Park the goal where the ball lands at the far end of the arc.
  WorldcupBallRoller.prototype.positionGoal = function (ballW) {
    if (!this.goal) return;
    var farY = -this.liftHeight; // arc apex term is 0 at p = 1
    var goalCenterX = this.home + this.travelX + ballW / 2;
    var gx = goalCenterX - this.goalW / 2;
    this.goal.style.transform =
      'translate(' + gx.toFixed(2) + 'px, calc(-50% + ' + farY.toFixed(2) +
      'px)) scale(' + (this.goalScale || 1).toFixed(3) + ')';
  };

  WorldcupBallRoller.prototype.getBallInstance = function () {
    return this.canvas.__worldcupBall || null;
  };

  WorldcupBallRoller.prototype.updatePosition = function () {
    this.ball.style.transform =
      'translate(' + this.x.toFixed(2) + 'px, calc(-50% + ' +
      this.y.toFixed(2) + 'px)) scale(' + this.scale.toFixed(3) + ')';
    this.ball.style.zIndex = this.scale < 0.92 ? '20' : '26';

    var ball = this.getBallInstance();
    if (!ball) return;
    // Tumble in place; the roller drives a faster spin while it flies away.
    ball.isRolling = false;
  };

  WorldcupBallRoller.prototype.boostSpin = function (amount) {
    var ball = this.getBallInstance();
    if (ball && !this.reducedMotion) {
      ball.spin += amount;
    }
  };

  // Position along the kick arc for progress p (0 = home, 1 = far point).
  WorldcupBallRoller.prototype.applyArc = function (p) {
    var e = easeOutCubic(p);
    this.x = this.home + this.travelX * e;
    this.scale = 1 + (this.effMinScale - 1) * e;
    // Parabolic hop (apex mid-flight) plus a net rise toward the horizon.
    this.y = -(this.arcApex * Math.sin(Math.PI * p)) - this.liftHeight * e;
  };

  WorldcupBallRoller.prototype.tick = function (dt) {
    if (this.reducedMotion || !this.canFly) {
      this.x = this.home;
      this.y = 0;
      this.scale = 1;
      this.updatePosition();
      return;
    }

    if (this.paused) {
      this.updatePosition();
      return;
    }

    this.phaseTime += dt;

    var p;
    switch (this.phase) {
      case ROLLER_PHASES.IDLE:
        this.x = this.home;
        this.y = 0;
        this.scale = 1;
        this.setGoal(0, false);
        if (this.phaseTime >= this.durations.idle) {
          this.phase = ROLLER_PHASES.KICK;
          this.phaseTime = 0;
        }
        break;

      case ROLLER_PHASES.KICK:
        // Kicked away into the distance along an arc, toward the goal.
        p = Math.min(this.phaseTime / this.durations.kick, 1);
        this.applyArc(p);
        this.boostSpin(0.16 * (1 - p) + 0.05);
        this.setGoal(Math.min(1, p * 1.6), false);
        if (p >= 1) {
          this.phase = ROLLER_PHASES.HOLD;
          this.phaseTime = 0;
          this.setGoal(1, true); // GOAL! shake the net
        }
        break;

      case ROLLER_PHASES.HOLD:
        this.applyArc(1);
        this.boostSpin(0.05);
        if (this.phaseTime >= this.durations.hold) {
          this.phase = ROLLER_PHASES.RETURN;
          this.phaseTime = 0;
        }
        break;

      case ROLLER_PHASES.RETURN:
        p = Math.min(this.phaseTime / this.durations.return, 1);
        // Reverse back down the arc.
        this.applyArc(1 - easeInOutCubic(p));
        this.boostSpin(0.06 * (1 - p));
        this.setGoal(1 - p, false);
        if (p >= 1) {
          this.phase = ROLLER_PHASES.IDLE;
          this.phaseTime = 0;
          this.x = this.home;
          this.scale = 1;
          this.y = 0;
        }
        break;
    }

    this.updatePosition();
  };

  WorldcupBallRoller.prototype.setGoal = function (opacity, scored) {
    if (!this.goal) return;
    if (this.noGoal) {
      this.goal.style.opacity = '0';
      this.goal.classList.remove('is-clickable');
      if (this.scored) { this.scored = false; this.goal.classList.remove('is-scored'); }
      return;
    }
    this.goal.style.opacity = opacity.toFixed(2);
    if (opacity > 0.12) {
      this.goal.classList.add('is-clickable');
    } else {
      this.goal.classList.remove('is-clickable');
    }
    if (scored && !this.scored) {
      this.scored = true;
      this.goal.classList.add('is-scored');
    } else if (!scored && this.scored && opacity <= 0) {
      this.scored = false;
      this.goal.classList.remove('is-scored');
    }
  };

  var rollerLoopStarted = false;
  var lastRollerTime = 0;

  function rollerLoop(time) {
    var dt = Math.min((time - lastRollerTime) / 1000, 0.05);
    lastRollerTime = time;

    document.querySelectorAll('.worldcup-header-ball-track').forEach(function (track) {
      if (track.__worldcupRoller) {
        track.__worldcupRoller.tick(dt);
      }
    });

    requestAnimationFrame(rollerLoop);
  }

  function startRollerLoop() {
    if (rollerLoopStarted) return;
    rollerLoopStarted = true;
    requestAnimationFrame(function (time) {
      lastRollerTime = time;
      rollerLoop(time);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-worldcup-ball]').forEach(function (canvas) {
      if (canvas.__worldcupBall) return;
      canvas.__worldcupBall = new WorldcupBall(canvas);
    });

    document.querySelectorAll('.worldcup-header-ball-track').forEach(function (track) {
      if (track.__worldcupRoller) return;
      track.__worldcupRoller = new WorldcupBallRoller(track);
    });

    document.querySelectorAll('[data-worldcup-countdown-link], [data-worldcup-goal]').forEach(bindCountdownLink);

    if (document.querySelector('.worldcup-header-ball-track')) {
      startRollerLoop();
    }

    if (window.location.hash === '#match-countdown') {
      requestAnimationFrame(function () {
        scrollToMatchCountdown('auto');
      });
    }
  }

  function scheduleInit() {
    requestAnimationFrame(function () {
      requestAnimationFrame(initAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
})();
